import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GetTokensQuery } from '../../API.service';

export class D2TApi {
  apiUrl: string;
  token: string;
  companyID: string;

  tokenData: GetTokensQuery | null;
  getImgFlag: number;
  saveFileFlag: number;

  constructor(private http: HttpClient, tokenData: GetTokensQuery | null) {
    this.tokenData = tokenData;
    this.apiUrl = environment.apiUrl;
    this.token = environment.token;
    this.companyID = environment.companyID;

    this.getImgFlag = 1;
    this.saveFileFlag = 1;
    this.token = environment.token;
    if (this.tokenData) {
      this.token = this.tokenData.uuid;
    }
  }

  ocrWeedex(formData: FormData) {
    const path = 'ocrWeedex';
    return this.uploadByPath(path, formData);
  }
  ocrPassport(formData: FormData) {
    const path = 'ocrPassport';
    return this.uploadByPath(path, formData);
  }

  ocrPassportTst(uid) {
    const path = 'ocrPassport';
    return this.getRequest(path, uid, environment.ocrPlusUrl);
  }

  ocrSihach(formData: FormData) {
    const path = 'ocrSihach';
    return this.uploadByPath(path, formData);
  }

  ocrSihachTst(uid) {
    const path = 'ocrSihach';
    return this.getRequest(path, uid);
  }

  ocrResume(formData: FormData) {
    const path = 'ocrResume';
    const url = `${environment.ocrPlusUrl}`;

    return this.uploadByPath(path, formData, url);
  }

  ocrResumeTst(uid) {
    const path = 'ocrResume';
    return this.getRequest(path, uid, environment.ocrPlusUrl);
  }

  ocrBarcode(formData: FormData) {
    const path = 'ocrBarcode';
    return this.uploadByPath(path, formData);
  }
  ocrTable(formData: FormData) {
    const path = 'ocrTable';
    const url = `${environment.ocrPlusUrl}`;

    return this.uploadByPath(path, formData, url);
  }
  ocrTextractTable(formData: FormData) {
    const path = 'ocrTextractTable';
    const url = `${environment.ocrPlusUrl}`;

    return this.uploadByPath(path, formData, url);
  }
  ocrPlus(formData: FormData) {
    const path = 'ocrPlus';
    // const url = 'http://127.0.0.1:5001'
    const url = `${environment.ocrPlusUrl}`;

    return this.uploadByPath(path, formData, url);
  }



  ocrPlusTst(uid = '') {
    const path = 'ocrPlus';

    const pathParams = `uid=${uid}`; //`owner=${owner}`;
    // const url = `http://127.0.0.1:5001/${path}?${pathParams}`;
    const url = `${environment.ocrPlusUrl}/${path}?${pathParams}`;
    const request$ = this.http.get(url, {});

    return request$;
  }

  ocrReceiptTst(uid) {
    const path = 'ocrReceipt';
    return this.getRequest(path, uid);
  }
  ocrPlusInvoiceTst(uid) {
    const path = 'ocrPlusInvoice';
    return this.getRequest(path, uid);
  }

  getRequest(path, uid, baseUrl:any = null) {
    if (!baseUrl) {
      baseUrl = environment.apiUrl;
    }

    let url = `${baseUrl}/${path}?uid=${uid}`;
    let headers = {};
    if (environment.apiUrl.includes('rapidapi')) {
      headers = {
        'X-RapidAPI-Key': '0c701e2971msh076cfe8a41e6225p155c68jsnc54fcd6e7ec1',
      };
    }
    return this.http.get(url, {
      headers: headers,
    });
  }

  ocrReceipt(formData: FormData) {
    const path = 'ocrReceipt';
    return this.uploadByPath(path, formData);
  }

  ocrPlusInvoice(formData: FormData) {
    const path = 'ocrPlusInvoice';
    return this.uploadByPath(path, formData);
  }

  private uploadByPath(
    path: string,
    formData: FormData,
    url: string | null = null
  ) {
    const pathParams = `getImg=${this.getImgFlag}&saveFile=${this.saveFileFlag}&token=${this.token}`;
    if (!url) {
      url = `${environment.apiUrl}/${path}?${pathParams}`;
    } else {
      url = `${url}/${path}?${pathParams}`;
    }
    // let url = `${environment.apiUrl}/${path}?${pathParams}`;
    let headers = {};
    if (environment.apiUrl.includes('rapidapi')) {
      headers = {
        'X-RapidAPI-Key': '0c701e2971msh076cfe8a41e6225p155c68jsnc54fcd6e7ec1',
      };
    }    
    const upload$ = this.http.post(url, formData, {
      headers,
      reportProgress: true,
      observe: 'events',
    });

    return upload$;
  }

  getBillings(owner) {
    const path = 'getBillings';
    const pathParams = `owner=${owner}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }

  getSumitPaymentMethods(owner) {
    const path = 'getSumitPaymentMethods';
    const pathParams = `owner=${owner}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }

  getSearchApiLog(owner, dateIsoStr) {
    const path = 'getSearchApiLog';
    const pathParams = `owner=${owner}&dateIsoStr=${dateIsoStr}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }

  getSumitPayments(owner) {
    const path = 'getSumitPayments';
    const pathParams = `owner=${owner}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }

  getBillingDataForToken() {
    const path = 'getBillingDataForToken';
    const pathParams = `token=${this.token}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }

  getPaymentMethods() {
    const path = 'getPaymentMethods';
    const pathParams = `token=${this.token}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }
  getBillInvoicePdf(id) {
    const path = 'getSumitInvoicePdf';
    const pathParams = `billingId=${id}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }

  getFileForApiLog(fileUid: string | null | undefined) {
    const path = 'getFileForApiLog';
    const pathParams = `fileUid=${fileUid}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }

  getAdminTokenData(owner: string | null | undefined) {
    const path = 'adminTokens';
    const pathParams = `owner=${owner}`;
    let url = `${environment.apiUrl}/${path}?${pathParams}`;
    const request$ = this.http.post(url, {});

    return request$;
  }
}
